export default "__VITE_ASSET__DeMVNL4o__"